import React, { useState } from "react";
import { useApp } from "@/context/AppContext";
import { adminUploadImage, fileUrl } from "@/lib/api";
import { Label } from "@/components/ui/label";
import { FileCheck2, UploadCloud, Loader2, X } from "lucide-react";
import { toast } from "sonner";

export const CertificateUpload = ({ path, onChange }) => {
  const { adminToken } = useApp();
  const [busy, setBusy] = useState(false);

  const upload = async (file) => {
    if (!file) return;
    if (file.size > 10 * 1024 * 1024) return toast.error("File must be under 10MB");
    setBusy(true);
    try {
      const res = await adminUploadImage(adminToken, file);
      onChange(res.path);
      toast.success("Certificate uploaded");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Upload failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="certificate-upload">
      <Label className="text-sm">Organic / Lab-Test Certificate (PDF or Image)</Label>
      <div className="mt-1 flex flex-wrap items-center gap-3">
        <input id="cert-input" type="file" accept="application/pdf,image/png,image/jpeg,image/webp"
          onChange={(e) => upload(e.target.files?.[0])} data-testid="cert-file-input" className="hidden" />
        <label htmlFor="cert-input" className="inline-flex items-center gap-2 px-4 py-2 rounded-md border border-[#15803D] text-[#15803D] text-sm font-semibold cursor-pointer hover:bg-[#F0FDF4]">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <UploadCloud className="w-4 h-4" />}
          {busy ? "Uploading..." : path ? "Replace" : "Upload Certificate"}
        </label>
        {path && (
          <>
            <a href={fileUrl(path)} target="_blank" rel="noopener noreferrer" data-testid="cert-preview-link"
              className="inline-flex items-center gap-1.5 text-sm text-[#15803D] font-semibold hover:underline">
              <FileCheck2 className="w-4 h-4" /> View
            </a>
            <button type="button" onClick={() => onChange("")} data-testid="cert-remove-btn"
              className="inline-flex items-center gap-1 text-xs text-rose-600 hover:underline">
              <X className="w-3.5 h-3.5" /> Remove
            </button>
          </>
        )}
      </div>
      <p className="text-xs text-slate-500 mt-1.5">Optional · Farmers can view it on the product page</p>
    </div>
  );
};
